












import { Component, Vue } from 'vue-property-decorator'

import VxCard from './VxCard.vue'

@Component({
  components: {
    VxCard
  }
})
export default class FullPage extends Vue {
}
